/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_How_Step1Inputs */



/**
* | output |
* | --- |
* | "Each customer runs in monthly periods, starting on the day you created them." |
*
* @param {Partner_Home_How_Step1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_how_step1 = /** @type {((inputs?: Partner_Home_How_Step1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_How_Step1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jeder Kunde läuft in monatlichen Zeiträumen, beginnend mit dem Tag, an dem Sie ihn angelegt haben.")
	return /** @type {LocalizedString} */ ("Each customer runs in monthly periods, starting on the day you created them.")
});